import { render } from "./notifications-alert.vue?vue&type=template&id=6a3e0f05"
import script from "./notifications-alert.vue?vue&type=script&lang=js"
export * from "./notifications-alert.vue?vue&type=script&lang=js"

import "./notifications-alert.vue?vue&type=style&index=0&id=6a3e0f05&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__